import { NavLink } from "react-router-dom";
import { Home, Sparkles, PlusCircle, Library, User, CalendarDays, Shield } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const TABS = [
  { to: "/", label: "Home", icon: Home, id: "home" },
  { to: "/muses", label: "Muses", icon: Sparkles, id: "muses" },
  { to: "/create", label: "Create", icon: PlusCircle, id: "create" },
  { to: "/library", label: "Library", icon: Library, id: "library" },
  { to: "/account", label: "Account", icon: User, id: "account" },
];

export const Logo = ({ className = "" }) => (
  <img src="/logo-horizontal.png" alt="Certified Muse Studio" className={`h-8 md:h-9 w-auto max-w-none self-start shrink-0 object-contain block ${className}`} data-testid="brand-logo" />
);

const linkCls = ({ isActive }) =>
  `flex items-center gap-2 px-4 py-2 rounded-full text-[12px] font-bold uppercase tracking-[0.12em] transition-colors ${
    isActive ? "bg-[#F1E9FE] text-[#9C4DDC]" : "text-[#6B6478] hover:text-[#1A1325]"
  }`;

const tabCls = ({ isActive }) =>
  `flex flex-col items-center gap-1 flex-1 py-2 text-[10px] font-bold tracking-wider uppercase transition-colors ${
    isActive ? "text-[#9C4DDC]" : "text-[#6B6478]"
  }`;

export default function Layout({ children }) {
  const { user } = useAuth();
  const side = [...TABS.slice(0, 3), { to: "/planner", label: "Planner", icon: CalendarDays, id: "planner" }, ...TABS.slice(3),
    ...(user?.is_admin ? [{ to: "/admin", label: "Admin", icon: Shield, id: "admin" }] : [])];
  return (
    <div className="min-h-screen">
      <header className="sticky top-0 z-40 bg-white border-b border-[#F0EAF7]">
        <div className="max-w-6xl mx-auto px-5 md:px-10 h-16 flex items-center justify-between gap-6">
          <NavLink to="/" data-testid="header-logo-link"><Logo /></NavLink>
          <nav className="hidden md:flex items-center gap-1" data-testid="desktop-sidebar">
            {side.map((t) => (
              <NavLink key={t.id} to={t.to} end={t.to === "/"} className={linkCls} data-testid={`sidebar-nav-${t.id}`}>
                <t.icon size={15} strokeWidth={2} /> <span className="hidden lg:inline">{t.label}</span>
              </NavLink>
            ))}
          </nav>
        </div>
      </header>
      <main className="min-w-0 pb-28 md:pb-12">
        <div className="max-w-5xl mx-auto px-5 md:px-10 pt-8 md:pt-12">{children}</div>
      </main>
      <nav
        className="md:hidden fixed bottom-0 inset-x-0 z-40 flex border-t border-[#F0EAF7] bg-white pb-[env(safe-area-inset-bottom)]"
        data-testid="mobile-tab-bar"
      >
        {TABS.map((t) => (
          <NavLink key={t.id} to={t.to} end={t.to === "/"} className={tabCls} data-testid={`tab-nav-${t.id}`}>
            <t.icon size={20} strokeWidth={1.5} />
            {t.label}
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
